const LOGIN_PATH = '/user/login';

/** 清除登录态并跳转登录页 */
export const logoutAndRedirectToLogin = () => {
  localStorage.removeItem('token');

  const { pathname, search } = window.location;
  if (pathname === LOGIN_PATH) {
    return;
  }

  const redirect = encodeURIComponent(pathname + search);
  window.location.replace(`${LOGIN_PATH}?redirect=${redirect}`);
};

/** 是否为未授权响应 */
export const isUnauthorizedStatus = (status?: number) =>
  status === 401 || status === 403;
